/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VendorStatus {
    UNKNOWN = 'Unknown',
    ACTIVE = 'Active',
    ARCHIVED = 'Archived',
}
